import CustomButton from "@/components/common/Button";
import navigationRoutes from "@/utils/navigationRoutes";
import { useNavigate } from "react-router-dom";

const NotFoundPage = ({
  title = "404",
  description = "Oops! The page you're looking for doesn't exist.",
  buttonText = "Go back to home",
  buttonLink = "/glucera/onboarding-welcome",
}: {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-5">
      <h1 className="text-6xl font-bold">{title}</h1>
      <div className="flex flex-col items-center justify-center gap-2">
        <p>{description}</p>
      </div>
      <CustomButton
        onClick={() => navigate(buttonLink)}
        type="primary"
        title="Navigate to Home Page"
      >
        {buttonText}
      </CustomButton>
    </div>
  );
};

export default NotFoundPage;
